import {
  CheckBox,
  FieldSet,
  FormContext,
  FormState,
  FormValues,
  InfoBlockLayout,
  InfoBlockStatus,
  Select,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Settings, SettingsContext } from "../../console/SettingsContext";
import { backupRetentionPeriods, backupSlots, getBackUpScheduleTimeRange } from "../../helpers/resourceHelper";

export const GROUP_MANAGEMENT = "management";

export const Fields = {
  backups: "vmdbDbSystemDeploymentDetails.dbHome.database.dbBackupConfig.autoBackupEnabled",
  retentionPeriod: "vmdbDbSystemDeploymentDetails.dbHome.database.dbBackupConfig.recoveryWindowInDays",
  scheduling: "vmdbDbSystemDeploymentDetails.dbHome.database.dbBackupConfig.autoBackupWindow",
};

export const ManagementTabContent = (): JSX.Element => {
  const { locale } = React.useContext<Settings>(SettingsContext);
  const [showBackupOptions, setShowBackupOptions] = React.useState(true);
  const form: FormState = React.useContext(FormContext);
  const [defaultBackupSchedule, setDefaultBackupSchedule] = React.useState<string>();
  const [defaultRetentionPeriod,
    setDefaultRetentionPeriod] = React.useState(backupRetentionPeriods.thirtyDaysPeriod.toString());
  const info = {
    messageType: InfoBlockStatus.INFO,
    message: Messages.createVmDb.managementTab.info.backupInfo(),
    infoLayout: InfoBlockLayout.Compact,

  };
  const onChangeShowBackUpOptions = (value: boolean): void => {
    setShowBackupOptions(value);
    if (value) {
      const formValues: FormValues = form.getGroupValues(GROUP_MANAGEMENT);
      setDefaultRetentionPeriod(formValues[Fields.retentionPeriod]?.length > 0
        ? formValues[Fields.retentionPeriod]?.[0].id
        : defaultRetentionPeriod);
      setDefaultBackupSchedule(formValues[Fields.scheduling]?.length > 0
        ? formValues[Fields.scheduling]?.[0].id : undefined);
    }
  };

  const retentionOptions = Object.values(backupRetentionPeriods).map(period => ({
    id: `${period}`,
    text: `${period} ${Messages.common.days()}`,
  }));

  const scheduleOptions = backupSlots.map(schedule => ({
    id: schedule.id,
    text: getBackUpScheduleTimeRange(schedule.id, locale),
  }));

  return (
    <FieldSet
      header={Messages.createVmDb.managementTab.sectionTitles.backupHeader()}
    >
      <CheckBox
        defaultValue={showBackupOptions}
        statusInfo={info}
        fieldName={Fields.backups}
        label={Messages.labels.enableAutomaticBackups()}
        onChange={value => onChangeShowBackUpOptions(value)}
      />
      {showBackupOptions && (
        <>
          <Select
            defaultValue={[defaultRetentionPeriod]}
            required
            fieldName={Fields.retentionPeriod}
            label={Messages.labels.backupRetentionPeriod()}
            options={retentionOptions}
            hideSearchBox
          />
          <Select
            defaultValue={defaultBackupSchedule ? [defaultBackupSchedule] : undefined}
            required
            fieldName={Fields.scheduling}
            label={`${Messages.labels.backupScheduling()} (UTC)`}
            options={scheduleOptions}
            hideSearchBox
          />
        </>
      )}
    </FieldSet>
  );
};
